<script lang="ts" setup>
import { computed } from 'vue'
import { useGalleryState } from '@/composables/useGalleryState'
import type { Image } from '@/types/Image'

const props = withDefaults(
  defineProps<{
    image: Image
    index: number
  }>(),
  {}
)
const emit = defineEmits<{
  (e: 'backToSwiper', index: number): void
}>()

const { activeSlide } = useGalleryState()

const displayImage = (index: number) => {
  emit('backToSwiper', index)
}

const isActive = computed(() => {
  return props.index === activeSlide.value
})
const imageWidthComputed = computed(() => {
  return props.image && props.image.sizes.ratio4x3.width > 0 ? props.image.sizes.ratio4x3.width : undefined
})
const imageHeightComputed = computed(() => {
  return props.image && props.image.sizes.ratio4x3.height > 0 ? props.image.sizes.ratio4x3.height : undefined
})
</script>

<template>
  <div :class="{ active: isActive }" class="thumbnail">
    <a @click="displayImage(index)">
      <img
        :alt="image.texts.description"
        :height="imageHeightComputed"
        :src="image.sizes.ratio4x3.src"
        :srcset="image.sizes.ratio4x3.srcset"
        :width="imageWidthComputed"
      />
    </a>
  </div>
</template>
